
import angular from 'angular';

// Pages
import loginPage from './loginPage/loginPage';

// adverts
import advertFeaturePage from './adverts/advertFeaturePage/advertFeaturePage';
import advertInlinePage from './adverts/advertInlinePage/advertInlinePage';
import advertExperiencePage from './adverts/advertExperiencePage/advertExperiencePage';
import advertnav from './adverts/advertnav/advertnav';
import advertFeatureList from './adverts/advertFeatureList/advertFeatureList';
import advertExperienceList from './adverts/advertExperienceList/advertExperienceList';
import advertForm from './adverts/advertForm/advertForm';
import advertAddPage from './adverts/advertAddPage/advertAddPage';
import advertEditPage from './adverts/advertEditPage/advertEditPage';
import advertInlineList from './adverts/advertInlineList/advertInlineList';
import advertInlineAddPage from './adverts/advertInlineAddPage/advertInlineAddPage';

// maps
import mapFilterAddPage from './map/mapFilterAddPage/mapFilterAddPage';
import mapFilterEditPage from './map/mapFilterEditPage/mapFilterEditPage';
import mapFilterList from './map/mapFilterList/mapFilterList';
import mapFilterPage from './map/mapFilterPage/mapFilterPage';
import mapFilterForm from './map/mapFilterForm/mapFilterForm';
import mapLocationAddPage from './map/mapLocationAddPage/mapLocationAddPage';
import mapLocationEditPage from './map/mapLocationEditPage/mapLocationEditPage';
import mapLocationList from './map/mapLocationList/mapLocationList';
import mapLocationPage from './map/mapLocationPage/mapLocationPage';
import mapLocationForm from './map/mapLocationForm/mapLocationForm';
import mapnav from './map/mapnav/mapnav';

// misc
import forbiddenPage from './forbiddenPage/forbiddenPage';
import profilePage from './profilePage/profilePage';
/* flagged for removal with task VRCSTORE-1037
import pushMessagesPage from './pushMessages/pushMessagesPage/pushMessagesPage';
*/
import racedaysPage from './racedays/racedaysPage/racedaysPage';
import racedaysAddPage from './racedays/racedaysAddPage/racedaysAddPage';
import racedayEditPage from './racedays/racedayEditPage/racedayEditPage';
import eventEditPage from './events/eventEditPage/eventEditPage';
import eventAddPage from './events/eventAddPage/eventAddPage';

//more items
import dynamicLinkListPage from './moreItems/dynamicLinkListPage/dynamicLinkListPage';
import dynamicLinkAddPage from './moreItems/dynamicLinkAddPage/dynamicLinkAddPage';
import dynamicLinkEditPage from './moreItems/dynamicLinkEditPage/dynamicLinkEditPage';

// social
import socialPage from './social/socialPage/socialPage';

// Components
import alert from './shared/alert/alert';
import textFormElement from './shared/textFormElement/textFormElement';
import passwordFormElement from './shared/passwordFormElement/passwordFormElement';
import validationError from './shared/validationError/validationError';
import navbar from './shared/navbar/navbar';
import footer from './shared/footer/footer';
import header from './shared/header/header';
import searchInput from './shared/searchInput/searchInput';
import login from './login/login';
import hamburger from './hamburger/hamburger';
import mobileSearch from './shared/mobileSearch/mobileSearch';
import locations from './locations/locations';
import locationFilters from './locationFilters/locationFilters';
import actionLink from './shared/actionLink/actionLink';
import previousLink from './shared/previousLink/previousLink';
import racedayAddForm from './racedays/racedayAddForm/racedayAddForm';
import racedayEditForm from './racedays/racedayEditForm/racedayEditForm';
import wysiwyg from './shared/wysiwyg/wysiwyg';
import formActions from './shared/formActions/formActions';
import radioFormElement from './shared/radioFormElement/radioFormElement';
import checkboxFormElement from './shared/checkboxFormElement/checkboxFormElement';
import dateFormElement from './shared/dateFormElement/dateFormElement';
import imageFormElement from './shared/imageFormElement/imageFormElement';
import nonRacingEvents from './nonRacingEvents/nonRacingEvents';
import selectFormElement from './shared/selectFormElement/selectFormElement';
import eventAddForm from './events/eventAddForm/eventAddForm';
import timeSelectFormElement from './shared/timeSelectFormElement/timeSelectFormElement';
import charCountTextarea from './shared/charCountTextarea/charCountTextarea';
import linkTypeChoice from './shared/linkTypeChoice/linkTypeChoice';
import addInput from './shared/addInput/addInput';
import addedItem from './shared/addedItem/addedItem';
import filterSelect from './shared/filterSelect/filterSelect';
import dynamicLinkEditForm from './moreItems/dynamicLinkEditForm/dynamicLinkEditForm';
import dynamicLinkFormElement from './shared/dynamicLinkFormElement/dynamicLinkFormElement';

let componentModule = angular.module('app.components', [
  alert,
  loginPage,
  advertFeaturePage,
  advertInlinePage,
  advertExperiencePage,
  advertnav,
  advertFeatureList,
  advertExperienceList,
  advertForm,
  advertAddPage,
  advertEditPage,
  advertInlineList,
  advertInlineAddPage,
  forbiddenPage,
  mapFilterAddPage,
  mapFilterEditPage,
  mapFilterList,
  mapFilterPage,
  mapFilterForm,
  mapLocationAddPage,
  mapLocationEditPage,
  mapLocationList,
  mapLocationPage,
  mapLocationForm,
  profilePage,
  /* flagged for removal with task VRCSTORE-1037
  pushMessagesPage,
  */
  racedaysPage,
  racedaysAddPage,
  racedayEditPage,
  racedayAddForm,
  socialPage,
  login,
  validationError,
  navbar,
  footer,
  header,
  mapnav,
  searchInput,
  textFormElement,
  passwordFormElement,
  hamburger,
  mobileSearch,
  locations,
  locationFilters,
  actionLink,
  previousLink,
  wysiwyg,
  formActions,
  radioFormElement,
  checkboxFormElement,
  dateFormElement,
  imageFormElement,
  racedayEditForm,
  nonRacingEvents,
  eventEditPage,
  eventAddPage,
  eventAddForm,
  selectFormElement,
  timeSelectFormElement,
  charCountTextarea,
  linkTypeChoice,
  addInput,
  addedItem,
  filterSelect,
  dynamicLinkListPage,
  dynamicLinkAddPage,
  dynamicLinkEditPage,
  dynamicLinkEditForm,
  dynamicLinkFormElement
])

.name;

export default componentModule;
